import { render, staticRenderFns } from "./Traslados_Bodegas.vue?vue&type=template&id=5d127323&scoped=true&"
import script from "./Traslados_Bodegas.vue?vue&type=script&lang=js&"
export * from "./Traslados_Bodegas.vue?vue&type=script&lang=js&"
import style0 from "./Traslados_Bodegas.vue?vue&type=style&index=0&id=5d127323&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d127323",
  null
  
)

export default component.exports